import React from 'react';
import { cn } from '../../utils/cn';
import { VEHICLE_PHOTO_FIT_CLASS } from '../../utils/vehiclePhoto';

/**
 * A vehicle photo inside a fixed box.
 *
 * Stored photos are whatever the operator's phone produced — mostly portrait, at ratios nothing
 * else in the product uses. Three fits were tried against the card grid's landscape box:
 * `object-cover` cropped the roof and the number plate off; `object-contain` pillarboxed the car
 * between slabs of grey; contain over a blurred copy of itself removed the grey but still left the
 * car small inside a box it did not fill.
 *
 * It STRETCHES. The frame is filled edge to edge and nothing is cut. The trade is proportions — a
 * portrait photo in a landscape box looks wide — which is accepted because losing the plate is
 * worse than a wide-looking car. Photos cropped from now on are framed at this box's own ratio in
 * the editor, so they are not distorted at all.
 *
 * The parent owns the box's size and ratio (see VEHICLE_PHOTO_ASPECT_CLASS).
 */
export const VehiclePhoto: React.FC<{
  src: string;
  alt: string;
  /** Applied to the photo. */
  className?: string;
  onError?: () => void;
}> = ({ src, alt, className, onError }) => {
  // Callers draw their own "sem foto" state, which is richer than anything generic here.
  if (!src) return null;

  return (
    <img
      src={src}
      alt={alt}
      onError={onError}
      className={cn('w-full h-full', VEHICLE_PHOTO_FIT_CLASS, className)}
    />
  );
};

export default VehiclePhoto;
